import { createContext, useContext, useEffect, useState } from "react";
import { X } from "lucide-react";

const Ctx = createContext(() => {});

export const ImageViewerProvider = ({ children }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!src) return;
    const onKey = (e) => {
      if (e.key === "Escape") setSrc(null);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [src]);

  return (
    <Ctx.Provider value={setSrc}>
      {children}
      {src && (
        <div
          className="fixed inset-0 z-[120] flex items-center justify-center bg-black/90 p-6 backdrop-blur-sm"
          onClick={() => setSrc(null)}
          data-testid="image-viewer"
        >
          <button
            onClick={() => setSrc(null)}
            className="absolute right-5 top-5 rounded-full bg-white/10 p-2.5 text-white transition-colors hover:bg-white/25"
            aria-label="Close"
            data-testid="image-viewer-close"
          >
            <X size={20} />
          </button>
          <img
            src={src}
            alt=""
            className="max-h-[85vh] max-w-[90vw] rounded-2xl object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            data-testid="image-viewer-img"
          />
        </div>
      )}
    </Ctx.Provider>
  );
};

export const useImageViewer = () => useContext(Ctx);
